const openModal = () => {
  const button = $('[data-event="modal"]');

  button.on('click', (event) => {
    event.preventDefault();
    const target = button.data('target');
    $(target).addClass('modal--active');
  });
};

const closeModal = () => {
  const button = $('[data-event="modal-close"]');

  button.on('click', (event) => {
    event.preventDefault();
    const modal = button.parents('.modal');
    $(modal).removeClass('modal--active');
  });
};

const modalModule = () => {
  openModal();
  closeModal();
};
export default modalModule;



// WEBPACK FOOTER //
// /app/app/assets/javascripts/packs/components/modal.js